import axios from "axios";
import React, { useState, useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import configs, { getParameterByName } from "../Constants";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import QRCode from "react-qr-code";
import TableBarIcon from "@mui/icons-material/TableBar";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ButtonGroup from "@mui/material/ButtonGroup";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import MediaCard from "./CardView";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import TextField from "@mui/material/TextField";
import { DialogContent, DialogActions } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useIntl } from "react-intl";
import DeleteDiaologue from "./sub_comp/Delete";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PeopleIcon from "@mui/icons-material/People";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
//import { db } from "./../root/util";
//import { onValue, ref } from "firebase/database";
//import Switch from "@mui/material/Switch";
import "./QRCodes.css";

function TableView(props) {
  const [tabNum, setTabNum] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isTableView, setIsTableView] = useState(false);
  const [viewMode, setViewMode] = useState("status"); // "status", "detail", "bookings"
  const [bookings, setBookings] = useState([]);
  const [filterDate, setFilterDate] = useState("");

  // Add/Edit booking form states
  const [bookingDialogOpen, setBookingDialogOpen] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [bookingName, setBookingName] = useState("");
  const [bookingPhone, setBookingPhone] = useState("");
  const [bookingEmail, setBookingEmail] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [bookingTime, setBookingTime] = useState("");
  const [bookingPeopleCount, setBookingPeopleCount] = useState("");
  const [bookingNote, setBookingNote] = useState("");

  // Delete booking dialog states
  const [openDeleteBookingDialog, setOpenDeleteBookingDialog] = useState(false);
  const [deleteBookingId, setDeleteBookingId] = useState(null);
  const [deleteBookingName, setDeleteBookingName] = useState("");

  const [logo, setLogo] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteitemName, setDeleteItemName] = useState("");
  const { formatMessage: t, locale, setLocale } = useIntl();
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  console.log(userData);
  const userToken = localStorage.getItem("token") || "";

  let baseURL = configs.baseURL;
  const userId = userData ? userData.sub : " ";
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  const getTabByUser = `${baseURL}/api/tables?merchantCode=${merchCode}`;
  let companyLogo = "/images/logo.png";
  let fbShouldCall = false;

  const fetchTableData = async () => {
    await axios.get(getTabByUser).then((response) => {
      setTableData(response.data);
    });
  };

  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/booking?userId=${merchCode}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      setBookings(response.data);
    } catch (error) {
      console.error("Failed to fetch bookings:", error);
      toast.error("Failed to fetch bookings");
    }
  };

  const closeBookingDialog = () => {
    setBookingDialogOpen(false);
    setBookingId("");
    setBookingName("");
    setBookingPhone("");
    setBookingEmail("");
    setBookingDate("");
    setBookingTime("");
    setBookingPeopleCount("");
    setBookingNote("");
  };

  const handleBookingSubmit = async (event) => {
    event.preventDefault();
    if (!bookingName || !bookingPhone || !bookingDate || !bookingTime || !bookingPeopleCount) {
      toast.error("Please fill in all mandatory fields.");
      return;
    }

    const payload = {
      name: bookingName,
      phone: bookingPhone,
      email: bookingEmail,
      date: bookingDate,
      time: bookingTime,
      people_count: parseInt(bookingPeopleCount),
      note: bookingNote,
      userId: merchCode,
    };

    try {
      if (bookingId) {
        await axios.put(`${baseURL}/api/booking/${bookingId}`, payload, {
          headers: { Authorization: `Bearer ${userToken}` }
        });
        toast.success("Booking updated successfully.");
      } else {
        await axios.post(`${baseURL}/api/booking`, payload, {
          headers: { Authorization: `Bearer ${userToken}` }
        });
        toast.success("Booking created successfully.");
      }
      fetchBookings();
      closeBookingDialog();
    } catch (error) {
      console.error("Failed to save booking:", error);
      toast.error("Failed to save booking.");
    }
  };

  const handleEditBooking = (booking) => {
    setBookingId(booking.id || booking._id);
    setBookingName(booking.name || "");
    setBookingPhone(booking.phone || "");
    setBookingEmail(booking.email || "");
    setBookingDate(booking.date || "");
    setBookingTime(booking.time || "");
    setBookingPeopleCount(booking.people_count || "");
    setBookingNote(booking.note || "");
    setBookingDialogOpen(true);
  };

  const handleDeleteBooking = (id, name, date) => {
    setDeleteBookingId(id);
    setDeleteBookingName(`Booking for ${name} on ${date}`);
    setOpenDeleteBookingDialog(true);
  };

  const handleDeleteBookingClose = () => {
    setOpenDeleteBookingDialog(false);
    setDeleteBookingId(null);
  };

  const handleConfirmDeleteBooking = async () => {
    if (!deleteBookingId) return;
    try {
      await axios.delete(`${baseURL}/api/booking/${deleteBookingId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      toast.success("Booking deleted successfully.");
      fetchBookings();
    } catch (error) {
      console.error("Failed to delete booking:", error);
      toast.error("Failed to delete booking.");
    }
    setOpenDeleteBookingDialog(false);
    setDeleteBookingId(null);
  };

  useEffect(() => {
    fetchTableData();
    fetchBookings();
  }, []);

  // Function to toggle availability
  const handleToggleAvailability = async (tableId) => {
    try {
      // Call backend API
      await axios.patch(
        `${baseURL}/api/tables/${tableId}/availability?merchantCode=${merchCode}`
      ).then((response) => {
          fetchTableData();
          setTableId("");
        });
      
    } catch (error) {
      console.error("Failed to update availability:", error);
    }
  };

  

  function base64Converter(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  base64Converter(merchantData ? merchantData.logoImg : "", function (dataUrl) {
    //console.log('RESULT:', dataUrl)
    setLogo(dataUrl);
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabCapcity, setTabCapcity] = useState([]);
  const [notes, setNotes] = useState("");
  const [isAvailable, setIsAvailable] = useState(false);
  const [tableId, setTableId] = useState("");

  const handleTabNum = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setTabNum(value);
    }
    // setTabNum(event.target.value);
  };

  const handleCapacity = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setTabCapcity(value);
    }
    // setTabCapcity(e.target.value);
  };

  const downloadQr = (element_id) => {
    const element = document.getElementById(element_id);
    document.getElementById(element_id).style.display = "block";
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const x = (pdfWidth - imgWidth * scaleFactor) / 2;
      const y = (pdfHeight - imgHeight * scaleFactor) / 2;

      pdf.addImage(
        imgData,
        "PNG",
        x,
        y,
        imgWidth * scaleFactor,
        imgHeight * scaleFactor
      );
      pdf.save("qrcode.pdf");
    });

    setTimeout(() => {
      document.getElementById(element_id).style.display = "none";
    }, 1000);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!tabNum) {
      console.log("All feilds are mandatry");
    } else if (tableId) {
      axios
        .put(`${baseURL}/api/tables/${tableId}?merchantCode=${merchCode}`, {
          number: tabNum,
          capacity: parseInt(tabCapcity),
          isAvailable: isAvailable,
          userId: merchCode,
          notes: notes,
        },
        { headers: { Authorization: `Bearer ${userToken}` } })
        .then((response) => {
          fetchTableData();
          setDialogOpen(false);
          setTableId("");
        });
    } else {
      // Check if table number already exists
      const tableExists = tableData.some(table => table.number === tabNum);
      if (tableExists) {
        toast.error("A table with this number already exists. Please use a different table number.");
        return;
      }

      axios
        .post(`${baseURL}/api/tables?merchantCode=${merchCode}`, {
          number: tabNum,
          capacity: parseInt(tabCapcity),
          isAvailable: true,
          userId: merchCode,
          notes: notes,
        },
        { headers: { Authorization: `Bearer ${userToken}` } })
        .then((response) => {
          fetchTableData();
          setDialogOpen(false);
          setIsAvailable(false);
          setNotes("");
          setTabCapcity("");
          setTabNum("");
          setSelectedOption("");
        });
    }
  };

  const handleDelete = (id,number) => {
    setDeleteItemId(id);
    setDeleteItemName(`Table #${number}`);
    setOpenDeleteDialog(true);
  };

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleConfirmDelete = () => {
    if (!deleteItemId) {
      return;
    }
    console.log(deleteItemId);
    axios
      .delete(
        `${baseURL}/api/tables/${deleteItemId}?merchantCode=${
          merchantData.length ? merchantData[0].merchantCode : " "
        }`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      )
      .then((response) => {
        console.log(response.data);
        fetchTableData();
      });
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleNote = (event) => {
    setNotes(event.target.value);
  };

  const handleAvail = () => {
    setIsAvailable(!isAvailable);
  };

  console.log("Tabel data that shubham want", tableData);

  const handleEdit = (tabId) => {
    console.log(tabId);
    let fltData = tableData.filter((tab) => tab.id === tabId);
    console.log(fltData);
    setTableId(fltData[0].id);
    setIsAvailable(fltData[0].isAvailable);
    setNotes(fltData[0].notes);
    setTabCapcity(fltData[0].capacity);
    setTabNum(fltData[0].number);
    setDialogOpen(true);
  };
    const filteredBookings = filterDate
    ? bookings.filter((b) => b.date === filterDate)
    : bookings;

  const sortedBookings = [...filteredBookings].sort((a, b) => {
    if (a.date !== b.date) {
      return b.date.localeCompare(a.date);
    }
    return a.time.localeCompare(b.time);
  });

  const groupedBookings = {};
  sortedBookings.forEach((b) => {
    const d = b.date || "No Date";
    if (!groupedBookings[d]) {
      groupedBookings[d] = [];
    }
    groupedBookings[d].push(b);
  });

  return (
    <div>
      <Dialog open={dialogOpen} maxWidth="md" fullWidth={true}>
        <DialogTitle style={{ fontWeight: "bold" }}>
          {tableId ? "Edit Table Info" : "Add Table Info"}
        </DialogTitle>

        <DialogContent dividers>
          <div
            className="container"
            style={{ padding: "20px 40px", borderRadius: "10px" }}
          >
            <TextField
              className="input_cls"
              fullWidth
              label="Enter table no."
              defaultValue=""
              onChange={handleTabNum}
              name="table_number"
              value={tabNum}
            />
            <br />
            <TextField
              className="input_cls"
              fullWidth
              label="Table Capacity"
              defaultValue=""
              onChange={handleCapacity}
              name="table_capacity"
              value={tabCapcity}
              sx={{ mt: 2 }}
            />
            <span
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                marginTop: "12px",
              }}
            >
              Available:
              <input
                type="checkbox"
                style={{
                  height: "25px",
                  width: "25px",
                  marginLeft: "5px",
                  accentColor: "#3622cc",
                }}
                checked={isAvailable}
                onChange={handleAvail}
              />
            </span>
            <TextField
              className="input_cls"
              fullWidth
              label="Enter notes"
              defaultValue=""
              onChange={handleNote}
              name="notes"
              value={notes}
              sx={{ mt: 2 }}
            />
            <br />
          </div>
        </DialogContent>

        <IconButton
          aria-label="close"
          onClick={() => {
            setDialogOpen(false);
            setIsAvailable(false);
            setNotes("");
            setTabCapcity("");
            setTabNum("");
            setTableId("");
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogActions>
          <Button
            color="error"
            style={{ margin: "10px" }}
            className="close-btn"
            onClick={() => {
              setDialogOpen(false);
              setIsAvailable(false);
              setNotes("");
              setTabCapcity("");
              setTabNum("");
              setTableId("");
            }}
          >
            Close
          </Button>
          <Button
            className="save-btn btnDialog-Fill"
            variant="contained"
            color="success"
            style={{ margin: "10px" }}
            onClick={(e) => handleSubmit(e)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {openDeleteDialog === true ? (
        <DeleteDiaologue
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteitemName}
          msg="delete"
        />
      ) : (
        <div />
      )}

      <div className="header">
        <h4>{t({ id: "manage_tables" })}</h4>
        <ButtonGroup aria-label="Basic button group">
          <Button
            variant={viewMode === "status" ? "contained" : "outlined"}
            style={{
              backgroundColor: viewMode === "status" ? "#F7C919" : "inherit",
              borderColor: "#F7C919",
              color: viewMode === "status" ? "black" : "inherit",
            }}
            onClick={() => {
              setIsTableView(false);
              setViewMode("status");
            }}
          >
            {t({ id: "status_view" })}
          </Button>
          <Button
            variant={viewMode === "detail" ? "contained" : "outlined"}
            style={{
              backgroundColor: viewMode === "detail" ? "#F7C919" : "inherit",
              borderColor: "#F7C919",
              color: viewMode === "detail" ? "black" : "inherit",
            }}
            onClick={() => {
              setIsTableView(true);
              setViewMode("detail");
            }}
          >
            {t({ id: "detail_view" })}
          </Button>
          <Button
            variant={viewMode === "bookings" ? "contained" : "outlined"}
            style={{
              backgroundColor: viewMode === "bookings" ? "#F7C919" : "inherit",
              borderColor: "#F7C919",
              color: viewMode === "bookings" ? "black" : "inherit",
            }}
            onClick={() => {
              setViewMode("bookings");
            }}
          >
            {t({ id: "bookings_view" })}
          </Button>
        </ButtonGroup>

        {viewMode === "bookings" ? (
          <button className="add_btn" onClick={() => setBookingDialogOpen(true)}>
            <AddIcon /> Add Booking
          </button>
        ) : (
          <button className="add_btn" onClick={() => setDialogOpen(true)}>
            <AddIcon /> Add Table
          </button>
        )}
      </div>
      {/* Edited By Sk */}
      {viewMode === "bookings" ? (
        <div style={{ padding: "20px" }}>
          {/* Date Filter & Search UI */}
          <div style={{ display: "flex", gap: "15px", alignItems: "center", marginBottom: "20px", background: "#f9f9f9", padding: "15px", borderRadius: "8px", border: "1px solid #eaeaea", flexWrap: "wrap" }}>
            <TextField
              label="Filter by Date"
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              style={{ backgroundColor: "white" }}
            />
            {filterDate && (
              <Button variant="outlined" color="secondary" onClick={() => setFilterDate("")} size="small">
                Clear Filter
              </Button>
            )}
            <div style={{ marginLeft: "auto", fontSize: "14px", color: "#666", fontWeight: "bold" }}>
              Total Bookings: {filteredBookings.length}
            </div>
          </div>

          {Object.keys(groupedBookings).length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", backgroundColor: "#f9f9f9", borderRadius: "10px", border: "1px dashed #ccc" }}>
              <CalendarMonthIcon style={{ fontSize: "60px", color: "#ccc", marginBottom: "10px" }} />
              <h5 style={{ margin: "5px 0", color: "#666", fontWeight: "bold" }}>No Bookings Found</h5>
              <p style={{ margin: 0, color: "#999", fontSize: "14px" }}>
                {filterDate ? "Try clearing the date filter to see all bookings." : "Click '+ Add Booking' to create your first booking."}
              </p>
            </div>
          ) : (
            Object.keys(groupedBookings).map((dateStr) => {
              let displayDate = dateStr;
              try {
                const dateObj = new Date(dateStr);
                if (!isNaN(dateObj)) {
                  displayDate = dateObj.toLocaleDateString(undefined, {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  });
                }
              } catch (e) {
                console.error(e);
              }

              return (
                <div key={dateStr} style={{ marginBottom: "30px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", borderBottom: "2px solid #F7C919", paddingBottom: "6px", marginBottom: "15px" }}>
                    <CalendarMonthIcon style={{ color: "#F7C919" }} />
                    <h5 style={{ margin: 0, fontWeight: "bold", color: "#333", fontSize: "18px" }}>
                      {displayDate}
                    </h5>
                    <span style={{ backgroundColor: "#F7C919", color: "black", padding: "2px 8px", borderRadius: "10px", fontSize: "12px", fontWeight: "bold", marginLeft: "8px" }}>
                      {groupedBookings[dateStr].length} {groupedBookings[dateStr].length === 1 ? "Booking" : "Bookings"}
                    </span>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
                    {groupedBookings[dateStr].map((booking) => (
                      <div
                        key={booking.id || booking._id}
                        style={{
                          backgroundColor: "white",
                          border: "1px solid #e0e0e0",
                          borderRadius: "12px",
                          padding: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
                          transition: "transform 0.2s, box-shadow 0.2s",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          cursor: "default",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-4px)";
                          e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.08)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "none";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.03)";
                        }}
                      >
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                            <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#fef6d2", color: "#f3be06", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "16px" }}>
                              {booking.name ? booking.name.charAt(0).toUpperCase() : "G"}
                            </div>
                            <div>
                              <h6 style={{ margin: 0, fontWeight: "bold", fontSize: "16px", color: "#333" }}>{booking.name}</h6>
                              <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#666", fontSize: "13px", marginTop: "2px" }}>
                                <AccessTimeIcon style={{ fontSize: "14px", color: "#888" }} />
                                <span>{booking.time}</span>
                              </div>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "14px", color: "#555", marginBottom: "15px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <PeopleIcon style={{ fontSize: "16px", color: "#888" }} />
                              <span><strong>{booking.people_count}</strong> People</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <PhoneIcon style={{ fontSize: "16px", color: "#888" }} />
                              <span>{booking.phone}</span>
                            </div>
                            {booking.email && (
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <EmailIcon style={{ fontSize: "16px", color: "#888" }} />
                                <span style={{ wordBreak: "break-all" }}>{booking.email}</span>
                              </div>
                            )}
                            {booking.note && (
                              <div style={{ marginTop: "8px", padding: "8px 12px", backgroundColor: "#fcf8e3", borderLeft: "3px solid #fbeed5", borderRadius: "4px", fontSize: "13px", fontStyle: "italic", color: "#c09853" }}>
                                <strong>Note: </strong>{booking.note}
                              </div>
                            )}
                          </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", borderTop: "1px solid #f0f0f0", paddingTop: "12px", marginTop: "10px" }}>
                          <IconButton
                            size="small"
                            color="info"
                            onClick={() => handleEditBooking(booking)}
                            style={{ backgroundColor: "#f0f8ff" }}
                          >
                            <EditIcon style={{ fontSize: "18px" }} />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteBooking(booking.id || booking._id, booking.name, booking.date)}
                            style={{ backgroundColor: "#fff5f5" }}
                          >
                            <DeleteIcon style={{ fontSize: "18px" }} />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </div>
      ) : isTableView ? (
        <div className="category-list" style={{ padding: "20px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead
              style={{
                borderBottom: "2px solid rgb(207 205 205)",
                margin: "5px",
              }}
            >
              <tr>
                <th>Table Number</th>
                <th>Capacity</th>
                <th>Notes</th>
                <th>Status</th>
                <th>Download QR</th>
                <th colSpan="2">Action</th>
              </tr>
            </thead>
            <tbody>
              {tableData &&
                tableData.map((tabInfo, k) => (
                  <tr
                    key={tabInfo.id}
                    style={{
                      borderBottom: "1px solid rgb(207 205 205)",
                      margin: "5px",
                    }}
                  >
                    <td style={{ fontWeight: "bold" }}>{tabInfo.number}</td>
                    <td>{tabInfo.capacity}</td>
                    <td>{tabInfo.notes}</td>
                    <td>
                      {tabInfo.isAvailable ? (
                        <span>
                          {" "}
                          <TableBarIcon style={{ color: "green" }} />
                        </span>
                      ) : (
                        <RestaurantMenuIcon style={{ color: "red" }} />
                      )}
                    </td>
                    <td align="center">
                      <div className="table_QRmain" id={"qr-img~" + k}>
                        <div className="table_QRsub">
                          <h1>{"TABLE #" + (k + 1)}</h1>
                          <div className="tableQRCode">
                            <p>
                              <b>Scan with Mobile Camera</b>
                            </p>
                            <QRCode
                              id="qrcode"
                              size={556}
                              style={{
                                // height: "280px",
                                // width: "280px",
                                height: "326px",
                                width: "314px",
                              }}
                              value={`${configs.ttoUrl}/?merchantCode=${merchCode}&isScan=true&tableNumber=${tabInfo.number}`}
                              // viewBox={0 0 456 456}
                            />
                          </div>
                          <div className="logos">
                            <img src={logo && logo} />
                            <div>
                              <span
                                style={{
                                  color: "#fff",
                                  display: "flex",
                                  flexDirection: "column",
                                  fontStyle: "italic",
                                }}
                              >
                                Powered by
                              </span>
                              <h5
                                style={{
                                  color: "#fff",
                                  fontSize: "27px",
                                  margin: "0px",
                                }}
                              >
                                {configs.productName}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <IconButton
                        aria-label="download"
                        size="large"
                        color="info"
                        // style={{marginLeft:"5rem"}}
                      >
                        <DownloadIcon
                          onClick={() => downloadQr("qr-img~" + k)}
                        />
                      </IconButton>
                    </td>
                    <td align="center">
                      <IconButton
                        aria-label="edit"
                        size="large"
                        color="info"
                        // style={{marginLeft:"5rem"}}
                        onClick={() => handleEdit(tabInfo.id)}
                      >
                        <EditIcon />
                      </IconButton>
                    </td>
                    <td align="center">
                      <IconButton
                        aria-label="delete"
                        size="large"
                        color="error"
                        onClick={() => handleDelete(tabInfo.id, tabInfo.number)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="media-card-container">
          {tableData.map((data, index) => (
            <MediaCard
              key={index}
              table={data.number}
              image={
                "https://images.pexels.com/photos/271696/pexels-photo-271696.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              }
              capacity={data.capacity}
              available={data.isAvailable}
              merchantCode={merchCode}
              onToggle={() => handleToggleAvailability(data.id)} // Pass toggle function
            />
          ))}
        </div>
      )}

      {/* Add / Edit Booking Dialog */}
      <Dialog open={bookingDialogOpen} onClose={closeBookingDialog} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: "bold" }}>
          {bookingId ? "Edit Booking Info" : "Add Booking Info"}
        </DialogTitle>

        <DialogContent dividers>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "10px 0" }}>
            <TextField
              fullWidth
              label="Guest Name *"
              value={bookingName}
              onChange={(e) => setBookingName(e.target.value)}
              placeholder="e.g. John Doe"
            />
            <TextField
              fullWidth
              label="Phone Number *"
              value={bookingPhone}
              onChange={(e) => setBookingPhone(e.target.value)}
              placeholder="e.g. +1 234 567 890"
            />
            <TextField
              fullWidth
              label="Email Address"
              value={bookingEmail}
              onChange={(e) => setBookingEmail(e.target.value)}
              placeholder="e.g. john@example.com"
              type="email"
            />
            <div style={{ display: "flex", gap: "15px" }}>
              <TextField
                fullWidth
                label="Booking Date *"
                type="date"
                value={bookingDate}
                onChange={(e) => setBookingDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                fullWidth
                label="Booking Time *"
                type="time"
                value={bookingTime}
                onChange={(e) => setBookingTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <TextField
              fullWidth
              label="Number of Guests *"
              type="number"
              value={bookingPeopleCount}
              onChange={(e) => setBookingPeopleCount(e.target.value)}
              placeholder="e.g. 4"
              InputProps={{ inputProps: { min: 1 } }}
            />
            <TextField
              fullWidth
              label="Special Notes"
              value={bookingNote}
              onChange={(e) => setBookingNote(e.target.value)}
              placeholder="e.g. Window table, high chair for toddler..."
              multiline
              rows={3}
            />
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "15px 24px" }}>
          <Button color="error" onClick={closeBookingDialog} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleBookingSubmit}
            variant="contained"
            color="success"
            style={{ backgroundColor: "#F7C919", color: "black", fontWeight: "bold" }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Booking Confirmation Dialog */}
      {openDeleteBookingDialog === true ? (
        <DeleteDiaologue
          open={openDeleteBookingDialog}
          onClose={handleDeleteBookingClose}
          onConfirm={handleConfirmDeleteBooking}
          itemName={deleteBookingName}
          msg="delete"
        />
      ) : (
        <div />
      )}
    </div>
  );
}

export default TableView;
